export default __webpack_public_path__ + "static/media/b.ac8bb58d.jpg";